import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icon from '~/Common-Objects/UI/Icon'
import Icons from '~/Common-Objects/UI/Icons/index'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import copy from 'copy-to-clipboard'
import { alterSnackbar } from '~/data/actions/siteActions'
import TwoColPaperExplainer from '~/Common-Objects/DomainManagement/Components/TwoColPaperExplainer'
import TierLimitHolder from '~/Common-Objects/UI/Cards/TierLimitHolder'

export default function TrackingSettings({
    updateDomain,
    setFlowStep,
    domainProvider,
    domainRecords,
    domain,
    subDomain = '',
    finish = () => {},
    finishedFlow = () => {}
}) {
    const site = useSelector((state) => state.siteMaster)
    const account = useSelector((state) => state.accountMaster)
    const dispatch = useDispatch()
    const copyVal = (val) => {
        copy(val)
        dispatch(alterSnackbar(true, 'Copied to clipboard'))
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            setFlowStep('cdnSettings')
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown)
        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    const newRecordsData = domainRecords
        .filter((record) => record.type == 'TRACKING')
        .map((record) => {
            const trackingDomainHost = domain?.trackingDomain?.domainName
                ? domain.trackingDomain.domainName.replace('.' + domain.domainName, '')
                : record.host
            let finalHost = record.host
            if (subDomain) {
                finalHost = finalHost + '.' + subDomain
            }
            return {
                type: {
                    headerValue: 'Type',
                    value: <SquareChip>{record.recordType}</SquareChip>
                },
                host: {
                    headerValue: 'Host',
                    value: (
                        <TextInput
                            readOnly={true}
                            value={finalHost}
                            iconRight={
                                <Icon
                                    name='copy'
                                    onClick={() => {
                                        copyVal(finalHost)
                                    }}
                                />
                            }
                        />
                    )
                },
                value: {
                    headerValue: 'Value/Target',
                    value: (
                        <TextInput
                            readOnly={true}
                            value={record.value}
                            iconRight={
                                <Icon
                                    name='copy'
                                    onClick={() => {
                                        copyVal(record.value)
                                    }}
                                />
                            }
                        />
                    )
                }
            }
        })

    const needsUpsell = account.accountMaster.accountType === 'free' && site.siteId === 1

    if (needsUpsell) {
        return (
            <TierLimitHolder
                err='tierForbids'
                feature='trackingDomains'
                tierName={account.tier.name}
                upsell={{ name: 'Starter' }}
                type='Tracking Subdomains'
                newLayout={true}
                noMarg={true}
                onUpgradeClickSilently={finish}
                inline={true}
                className='warning-holder-transparent'
                buttonClassName='button-primary'
                description={i18n.t('company:domains.domainManagement.trackingExplainerContent')}
                extraCta={
                    <Button
                        text={i18n.t('company:domains.domainManagement.continueAndVerify')}
                        iconRight={<Icons icon='arrowRight' />}
                        className='button-sml'
                        onClick={() => {
                            updateDomain({
                                options: {
                                    cdnEnabled: false,
                                    trackingEnabled: false
                                }
                            })
                            finishedFlow()
                        }}
                    />
                }
            />
        )
    }

    return (
        <>
            <div>{i18n.t('company:domains.domainManagement.addRecord', { provider: domainProvider?.label })}</div>
            <DataTable1
                tableData={newRecordsData}
                loadingData={[]}
                dataUpdater={() => {}}
                width='100%'
                pageSize='100'
                hasCheckBoxes='no'
                sortedColumn={''}
                sortedDirection={''}
                className='mar-b20'
            />

            <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
                <Button
                    text={i18n.t('company:domains.domainManagement.continue')}
                    iconRight={<Icons icon='arrowRight' />}
                    className='button-primary'
                    onClick={() => {
                        updateDomain({
                            options: {
                                trackingEnabled: true
                            }
                        })
                        setFlowStep('cdnSettings')
                    }}
                />

                <a
                    onClick={() => {
                        updateDomain({
                            options: {
                                trackingEnabled: false
                            }
                        })
                        setFlowStep('cdnSettings')
                    }}
                >
                    {i18n.t('company:domains.domainManagement.skip')}
                </a>
            </div>
            <TwoColPaperExplainer
                className='mar-t20 mar-b5'
                title={i18n.t('company:domains.domainManagement.trackingExplainerTitle')}
                content={i18n.t('company:domains.domainManagement.trackingExplainerContent')}
            />
        </>
    )
}
